import { apiClient } from "../API/axiosInstance";
import { store } from "../store";
import { logger } from "../utils/logger";

export class OrganisationService {
  static async createOrganisation(organisation) {
    const response = await apiClient.post("/organisation", organisation);
    return response;
  }

  static async addOrganisationMember(member, organisationId) {
    try {
      const response = await apiClient.post(
        "/organisation/" + organisationId + "/member/",
        member
      );
      return response;
    } catch (error) {
      return error;
    }
  }

  static async fetchOrganisations() {
    const response = await apiClient.get("/organisation");
    return response.data || [];
  }

  static async fetchOrganisation(orgId) {
    const response = await apiClient.get(`/organisation/${orgId}`);
    return response.data;
  }

  static async fetchOrganisationMembers(org_id) {
    const response = await apiClient.get(`/organisation/${org_id}/members`);
    return response.data || [];
  }

  static async fetchOrganisationUsers(orgId) {
    const response = await apiClient.get(`/organisation/${orgId}/users`);
    return response.data || [];
  }

  static async fetchOrganisationRoles(orgID) {
    if (orgID === undefined || orgID === 0) return [];
    const result = await apiClient.get(`/organisation/${orgID}/roles`);
    return result.data || [];
  }

  static async fetchOrganisationLogs(organisationID) {
    try {
      const response = await apiClient.get(
        `/organisation/${organisationID}/logs`
      );
      return response.data || [];
    } catch (error) {
      logger.error("Error fetching organisation logs: ", error);
      return [];
    }
  }

  static async deleteOrganisation(organisationId) {
    const response = await apiClient.delete(`/organisation/${organisationId}`);
    return response;
  }

  static async updateOrganisation(organisationId, data) {
    const response = await apiClient.put(
      `/organisation/${organisationId}`,
      data
    );
    return response;
  }

  static async deleteOrganisationMember(organisation_id, member_id) {
    const response = await apiClient.delete(
      `/organisation/${organisation_id}/members/${member_id}`
    );
    return response;
  }

  static async inviteUser(orgId, userData) {
    const response = await apiClient.post(
      `/organisation/${orgId}/invite`,
      userData
    );
    return response;
  }

  static async removeUser(orgId, userId) {
    const response = await apiClient.delete(
      `/organisation/${orgId}/users/${userId}`
    );
    return response;
  }

  static async setOrganisationMemberRoles(
    organisationMemberRole,
    organisationId
  ) {
    if (!organisationMemberRole || !organisationId) {
      return;
    }
    //{organisation_id}/roles/{user_id}
    let result = await apiClient.put(
      `/organisation/${organisationId}/roles/${organisationMemberRole.user_id}`,
      organisationMemberRole
    );

    return result;
  }

  static setSelectedOrganisation(organisation) {
    store.dispatch({
      type: "selectedOrganisation/update",
      payload: organisation,
    });
  }

  static async fetchRemainingDeviceLimit(organisationId) {
    if (!organisationId) {
      return 0;
    }

    try {
      const response = await apiClient.get(
        `/organisation/${organisationId}/remaining-device-limit`
      );

      return response.data;
    } catch (error) {
      logger.error(error);
      return 0;
    }
  }

  static hasPermission(organisationUserRoles, userID, role) {
    if (!Array.isArray(organisationUserRoles) || !userID || !role) {
      return false;
    }

    let userRole = organisationUserRoles.find(
      (userrole) => parseInt(userrole.user_id) === parseInt(userID)
    );

    if (!userRole) {
      return false;
    }

    if (userRole.admin_permission) {
      return true;
    }

    if (role === "add") {
      return userRole.add_permission;
    } else if (role === "edit") {
      return userRole.edit_permission;
    } else if (role === "delete") {
      return userRole.delete_permission;
    } else if (role === "transfer") {
      return userRole.transfer_permission;
    }

    return false;
  }
}
